import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ApiContentService } from '../../../api/api-content.service';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert/dist/sweetalert.min.js';

@Component({
  selector: 'app-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.css'],
  providers: [ DatePipe ]
})
export class TncComponent implements OnInit {

  constructor(
    public rest: ApiContentService,
    public route: ActivatedRoute,
    public datepipe: DatePipe,
    private router: Router
  ) { }

  errorMsg:any = []

  dataall:any = {}
  dataprospek:any = {}
  dataprospekidentity:any = {}
  dataprospekinstall:any = {}
  dataprospekorder:any = {}
  dataprospekbonus:any = {}
  dataprospekdiscount:any = {}

  curScrollPos = 0
  endReached = false
  checkBtn = true
  btnLoad1 = false
  btnLoad2 = false
  notAuth = false
  dataContent = false
  dataSummary = false

  logoimage:any = 'data:image/png;base64,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'
                  

  ngOnInit() {
    this.firstModal()
    this.notAuth = false
    this.dataContent = false
    this.dataSummary = false

    localStorage.removeItem('currentUser');

    let params = this.route.snapshot.paramMap.get('encrypt')
    var decrypt = atob(params)
    decrypt = decrypt.replace('_xx_','+').replace('_mm_','/')
    var arrs = decrypt.split('_vv_')
    console.log(arrs)

    const data = {
      'data':{
        'access_token': arrs[2]
      }
    }
    localStorage.setItem('currentUser', JSON.stringify(data));
    this.checkApprove(params)
  }
  
  firstModal(){
    swal("Processing your request...", {
      buttons: false,
      closeOnClickOutside: false,
    })
  }

  updateScrollPos(e) {
    this.curScrollPos = e.pos
    this.endReached = e.endReached

    //console.log(e)
    // if(this.endReached == true){
    if(this.endReached == true || e.pos > 3000){
      this.checkBtn = false
    }
  }

  checkApprove(params:any){
    this.rest.checkapprove(params).subscribe((response:any) => {
      console.log(response)
      if(response.status == false){
        this.getTnc(params)
      }else{
        setTimeout(() => {
          this.router.navigate(['tncapprove/'+response.url]);
        }, 500);
      }
    })
  }

  getTnc(params:any){
    this.rest.getdatatnc(params).subscribe((response:any) => {
      console.log(response)
      if(response.status == false){
        swal.close()
        setTimeout(() => {
          this.notAuth = true
          this.errorMsg = response.message
        }, 500);

      }else{

        this.dataall = response.data
        this.dataprospek = response.data.prospek
        this.dataprospekinstall = response.data.prospek.prospek_install
        this.dataprospekidentity = response.data.prospek.prospek_identity
        this.dataprospekorder = response.data.order
        this.dataprospekbonus = response.data.bonus
        this.dataprospekdiscount = response.data.discount

        swal.close()
        setTimeout(() => {
          // this.dataContent = true
          this.dataSummary = true
          console.log(this.dataprospek.prospek_id)
        }, 500);
      }
    })
  }

  nextTnc(){
    this.dataSummary = false
    this.dataContent = true
  }
  backTnc(){
    this.dataContent = false
    this.dataSummary = true
    this.checkBtn = true
  }

  submitTnc(apr:any){
    var aprtext = ""
    if(apr == 1){
      this.btnLoad1 = true
      aprtext = "Anda menyatakan SETUJU dengan semua syarat dan ketentuan yang tertera dengan mengklik tombol OK."
    }else{
      this.btnLoad2 = true
      aprtext = "Anda menyatakan TIDAK SETUJU dengan semua syarat dan ketentuan yang tertera dengan mengklik tombol OK."
    }

    setTimeout(() => {
      swal({
        title: "Perhatian!",
        text: aprtext,
        icon: "warning",
        buttons: true,
        dangerMode: true,
        closeOnClickOutside: false
      })
      .then((confirm) => {
        if (confirm) {
          let params1 = this.dataprospek.id
          let params2 = this.dataprospekidentity.nama
          let params3 = this.dataprospekidentity.email
          // var secret = '0hW4w!';
          var encrypt = btoa(params1+'_vv_'+params2+'_vv_'+params3)
          encrypt = encrypt.replace(/[+]/g,'_xx_').replace(/[/]/g,'_mm_').replace(/[=]/g,'')
          var data = {
            'encrypt': encrypt,
            'email': this.dataprospekidentity.email,
            'approve': apr
          }
         // console.log(encrypt);
          //console.log(params1,data);
          //return;
          this.rest.approvetnc(params1, data).subscribe((response:any) => {
            console.log(response)
            this.btnLoad1 = false
            this.btnLoad2 = false
            if(response.status == true){
              setTimeout(() => {
                this.router.navigate(['tncapprove/'+encrypt]);
              }, 500);
            }
          })
        }else{
          this.btnLoad1 = false
          this.btnLoad2 = false
        }
      })
    }, 300);
  }
}


